
































import Vue from 'vue'
import ModalOverlay from '@/common/components/ModalOverlay.vue'
import { browser } from '@/common/userAgent'
export default Vue.extend({
  components: { ModalOverlay },
  props: {
    showCloseBtn: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  data(): { scrollPosition: number } {
    return { scrollPosition: 0 }
  },
  created() {
    document.documentElement.style.scrollBehavior = 'auto'
    this.scrollPosition = window.pageYOffset
  },
  mounted() {
    if (browser.isIOS) {
      document.documentElement.classList.add('ios-only')
      document.body.classList.add('ios-only')
    }
  },
  beforeDestroy() {
    if (browser.isIOS) {
      document.documentElement.classList.remove('ios-only')
      document.body.classList.remove('ios-only')
    }
  },
  destroyed() {
    window.scrollTo(0, this.scrollPosition)
    document.documentElement.style.scrollBehavior = 'smooth'
  }
})
